import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import {
  PrevBtn,
  NextBtn,
  PaginationWrapper,
  UserImage,
} from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { MdOutlineChevronRight } from "react-icons/md";
import moment from "moment";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../helpers";
import { IoCopySharp } from "react-icons/io5";
import Tooltip from "../Tooltip";
import { useNavigate } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";

const CommissionTable = ({
  apiData,
  setSelectedData,
  selectedData,
  getCommissionPaidMutate,
  activeTab,
  setCollectionDetail,
  getCollectionListMutate,
}) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const storageKey = `commission_page_index`;
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);

  const showCommissionPaid = (item) => {
    setSelectedData(item);
    getCommissionPaidMutate(item.dealId);
  };

  const showCollection = (item) => {
    // setSelectedInventory(item);
    getCollectionListMutate(item.tenantId);
    setOpenActionMenu(null);
  };

  // Helper function to format currency
  const formatCurrency = (amount) => {
    if (!amount) return "₹0";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };


  const ActionBtns = (item) => (
    <div className="flex items-center gap-3">
      <Tooltip label="Track Commission">
        <button
          onClick={() => {
            showCommissionPaid(item);
          }}
          className="text-gray-400 hover:text-gray-600 transition bg-gray-50 rounded-full p-1.5"
        >
          <MdOutlineChevronRight size={22} />
        </button>
      </Tooltip>
    </div>
  );

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => {
        if (activeTab === "1") {
          return {
            client: getClientName(item),
            inventory: getAddress(item),
            commission: getCommissionCell(item),
            pending: getPendingCell(item),
            action: ActionBtns(item),
            original: item,
          };
        } else {
          return {
            client: getTenantName(item),
            inventory: getLeaseAddress(item),
            margin: getRentCell(item),
            pending: getCollectionCell(item),
            action: ActionBtns(item),
            original: item,
          };
        }
      });
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  //---Active lease data-----

  const getTenantName = (item) => {
    return (
      <UserImageWrapper
        className="cursor-pointer"
        onClick={() => {
          if (item?.tenantId) {
            navigate(`/tenant/${item.tenantId}`);
          }
        }}
      >
        <div className="flex-row flex">
          <UserImage src={Images.Avatar} alt={`Avatar`} />
        </div>
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="text-gray-600 text-sm font-medium">
              {item.tenantName
                ? item.tenantName.charAt(0).toUpperCase() +
                item.tenantName.slice(1)
                : "N/A"}
            </span>
          </div>
          <div className="flex items-centre gap-1 text-xs text-gray-400">
            <span className="">#{item.tenantMobile || "N/A"}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.tenantMobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy Number"
            >
              <IoCopySharp size={12} />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };

  const getLeaseAddress = (item) => {
    if (!item) return <span className="text-gray-400">N/A</span>;

    return (
      <div className="flex flex-col gap-1">
        <span className="text-gray-600 text-sm font-medium truncate max-w-[130px]">
          {item.inventoryName
            ? item.inventoryName.charAt(0).toUpperCase() +
            item.inventoryName.slice(1)
            : "N/A"}
        </span>
        <span className="text-gray-400 text-xs">
          {item.inventoryAddress
            ? capitalizeFirstLetter(truncateText(item.inventoryAddress, 20))
            : "N/A"}
        </span>
      </div>
    );
  };

  const getRentCell = (item) => {
    const broker = (item.brokerShare || 0);
    const owner = (item.ownerPayout || 0);
    const rent = (item.tenantRent || 0);

    const content = (
      <span
        className="
        inline-flex items-center w-fit
        py-0 rounded-full
        text-green-700
        text-xs font-semibold
      "
      >
        {formatCurrency(broker)}
      </span>
    );

    if (owner || rent) {
      return (
        <Tooltip
          label={
            <div className="text-xs leading-5">
              <div>Owner Rent: {formatCurrency(owner)}</div>
              <div>Tenant Rent: {formatCurrency(rent)}</div>
            </div>
          }
        >
          <div className="flex flex-col gap-1 cursor-pointer">{content}</div>
        </Tooltip>
      );
    }

    return <div className="flex flex-col gap-1">{content}</div>;
  };

  // const getCollectionCell = (item) => (
  //   <div className="flex items-center gap-2">
  //     <span
  //       // onClick={() => setCollectionDetail(true)}
  //       onClick={() => showCollection(item)}
  //       className="px-3 py-1.5 text-sm text-blue-600 bg-blue-50 font-medium flex items-center gap-2 rounded-full transition cursor-pointer">
  //       ₹{item.collections || 0}
  //       <FiChevronRight size={14} />
  //     </span>
  //   </div>
  // );
  const getCollectionCell = (item) => {
    const hasData = item?.collections > 0;

    return (
      <div className="flex items-center gap-2">
        <span
          onClick={hasData ? () => showCollection(item) : undefined}
          className={`px-3 py-1.5 text-sm font-medium flex items-center gap-2 rounded-full transition
          ${hasData
              ? "text-blue-600 bg-blue-50 cursor-pointer"
              : "text-gray-400 bg-gray-100 cursor-not-allowed"}
        `}
        >
          {item.collections === 0
            ? 'No Collection'
            : `₹${item.collections || 0}`}


          {/* Show arrow only if data exists */}
          {hasData && <FiChevronRight size={14} />}
        </span>
      </div>
    );
  };
  //----data------
  // Cell renderers
  const getClientName = (item) => {
    let label = "";
    let badgeStyle = "";

    if (item?.commissionPaidBy === Config.PAID_BY_TYPE.BUYER) {
      label = "B";
      badgeStyle = "bg-blue-100 text-blue-600";
    } else if (item?.commissionPaidBy === Config.PAID_BY_TYPE.SELLER) {
      label = "S";
      badgeStyle = "bg-purple-100 text-purple-600";
    }

    if (!item) return <span className="text-gray-400">N/A</span>;

    return (
      <UserImageWrapper>
        <div className="flex-row flex">
          <UserImage src={Images.Avatar} alt={`Avatar`} />
        </div>
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="text-gray-600 text-sm font-medium">
              {item.clientName
                ? item.clientName.charAt(0).toUpperCase() +
                item.clientName.slice(1)
                : "N/A"}
            </span>
            {label && (
              <span
                className={`px-1 text-[10px] font-semibold rounded-full ${badgeStyle}`}
              >
                {label}
              </span>
            )}
          </div>
          <div className="flex items-centre gap-1 text-xs text-gray-400">
            <span className="">#{item.clientMobile || "N/A"}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.clientMobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy Number"
            >
              <IoCopySharp size={12} />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };

  const getAddress = (item) => {
    if (!item) return <span className="text-gray-400">N/A</span>;

    return (
      <div className="flex flex-col gap-1">
        <span className="text-gray-600 text-sm font-medium truncate max-w-[130px]">
          {item.inventoryName
            ? item.inventoryName.charAt(0).toUpperCase() +
            item.inventoryName.slice(1)
            : "N/A"}
        </span>
        <span className="text-gray-400 text-xs">
          {item.address
            ? capitalizeFirstLetter(truncateText(item.address, 20))
            : "N/A"}
        </span>
      </div>
    );
  };

  const getCommissionCell = (item) => (
    <div
      className="flex flex-col gap-1 cursor-pointer"
      onClick={() => showCommissionPaid(item)}
    >
      <span
        className="
                inline-flex items-center w-fit
                py-0 rounded-full
                text-green-700
                text-xs font-semibold
                "
      >
        {formatCurrency(item.amount)}
      </span>

      <span className="text-[11px] text-gray-400">
        Deal · {formatCurrency(item.dealValue)}
      </span>
    </div>
  );

  const getPendingCell = (item) => (
    <span className="text-sm font-medium text-orange-600">
      {item.balance > 0 ? (
        <Amount>{formatCurrency(item.balance)}</Amount>
      ) : (
        <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
          No dues
        </span>
      )}
    </span>
  );


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        { Header: "Client", accessor: "client" },
        { Header: "Status", accessor: "status" },
      ];
    }
    if (activeTab === "1") {
      // Commission
      return [
        { Header: "Client", accessor: "client" },
        { Header: "Inventory", accessor: "inventory" },
        { Header: "Commission", accessor: "commission" },
        { Header: "Pending", accessor: "pending" },
        { Header: "Action", accessor: "action" },
      ];
    } else {
      // Active Lease
      return [
        { Header: "Tenant", accessor: "client" },
        { Header: "Inventory", accessor: "inventory" },
        { Header: "Margin", accessor: "margin" },
        { Header: "Collections", accessor: "pending" },
        // { Header: "Action", accessor: "action" },
      ];
    }
  }, [isMobileView, activeTab]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={column.style}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        style={cell.column.style}
                      //  onClick={() => {
                      //    if (
                      //      cellIndex === 0 ||
                      //      (cellIndex === 1 && window.innerWidth < 768)
                      //    ) {
                      //      toggleRow(rowIndex);
                      //    }
                      //  }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page {pageIndex + 1} of {pageOptions.length}
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={previousPage} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="prev" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={nextPage} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="next"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const Amount = tw.p`
  text-rose-700
  bg-rose-50
  text-sm
  font-semibold
  px-3 py-1
  rounded-full
  inline-flex
  cursor-pointer
`;
export default CommissionTable;
